import React from 'react';
import { FormattedMessage } from 'react-intl';
import SuperpositionHeader from "../../Header/SuperpositionHeader";
import { CancelButton, SaveButton } from '../../../elements/ActionButtons/index';

const PaymentForm = () => {
  return(
    <div>
      <FormattedMessage id='ids_banks'>
        {backBtnText => (
          <SuperpositionHeader backUrl="/payments" backBtnText={backBtnText}>
            <div className="space-between" style={{ width: "calc(250px + 5%)" }}>
              <CancelButton onClick={(e) => console.log("cancel", e)} />
              <SaveButton fill onClick={(e) => console.log("save", e)} />
            </div>
          </SuperpositionHeader>
        )}
      </FormattedMessage>
      <h1>Payment creation</h1>
    </div>
  )
}

export default PaymentForm;
